import { AccessPass, CaliforniaEBT, DisabilityValidation, MetroTAP, SeniorSelfCert, NevadaEBT, StudentValidation, BusinessValidation } from "./validation";
import { NOT_ELIGIBLE_TYPE } from "../../stores/stateDefaults";

export const needsRecertifiedFunctions = {
  // this is currently not in use
  never: () => true,
  oneYear: lastValidatedDate => ((new Date() - lastValidatedDate) < 1000 * 60 * 60 * 24 * 365),
};

export const notEligible = {
  title: "Full Fare",
  description: "Not eligible for reduced fare",
  image: "fa-bicycle.svg",
  type: NOT_ELIGIBLE_TYPE,
};

export const reducedFareTypes = {
  phl: [
    notEligible,
    {
      title: "Reduced Fare",
      description: "For PA ACCESS card holders",
      type: "accessCard",
      recertFrequency: "oneYear",
      image: "access-passes.svg",
      validationComponent: AccessPass,
      discountVerificationType: "access",
    },
  ],
  lax: [
    notEligible,
    {
      title: "EBT",
      description: "For Golden State Advantage EBT cardholders",
      type: "californiaEBT",
      recertFrequency: "oneYear",
      image: "ebt-icon.svg",
      validationComponent: CaliforniaEBT,
      discountVerificationType: "metro_rf",
    },
    {
      title: "Student",
      description: "For students 16+",
      type: "studentEmail",
      recertFrequency: "oneYear",
      image: "student-icon.svg",
      validationComponent: StudentValidation,
      discountVerificationType: "metro_rf",
    },
    {
      title: "Senior",
      description: "For seniors 62+",
      type: "senior",
      recertFrequency: "never",
      image: "senior-icon.svg",
      validationComponent: SeniorSelfCert,
      discountVerificationType: "metro_rf",
    },
    {
      title: "Disability",
      description: "For people with ADA-recognized disabilities",
      type: "disability",
      recertFrequency: "never",
      image: "disabled-icon.svg",
      validationComponent: DisabilityValidation,
      discountVerificationType: "metro_rf",
    },
    {
      title: "Reduced Fare TAP",
      description: "For Transit Assistance Program cardholders",
      type: "metroTAP",
      recertFrequency: "oneYear",
      image: "tap-icon.svg",
      validationComponent: MetroTAP,
      discountVerificationType: "metro_rf",
    },
    {
      title: "Bike Share for Business",
      description: "For employees of participating organizations",
      type: "businessEmail",
      recertFrequency: "oneYear",
      image: "fa-bicycle.svg",
      validationComponent: BusinessValidation,
      discountVerificationType: "businessEmail",
    },
  ],
  las: [
    notEligible,
    {
      title: "Nevada EBT Card",
      description: "For Nevada EBT cardholders",
      type: "nevadaEBT",
      recertFrequency: "oneYear",
      image: "nevada-ebt.png",
      validationComponent: NevadaEBT,
      discountVerificationType: "nevada_rf",
    },
  ],
};